module.exports = __webpack_public_path__ + "images/FUSA_icons/024-money.bf0fcbb7f53476859d0207370499dc47.svg";